export default __webpack_public_path__ + "static/media/brasil-flag.9beec248.svg";